import { render, staticRenderFns } from "./FormularioNinos.vue?vue&type=template&id=68cdae3e&scoped=true"
import script from "./FormularioNinos.vue?vue&type=script&lang=js"
export * from "./FormularioNinos.vue?vue&type=script&lang=js"
import style0 from "./FormularioNinos.vue?vue&type=style&index=0&id=68cdae3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cdae3e",
  null
  
)

export default component.exports